import {grey} from 'material-ui/colors/index'

const styles = theme => ({
  tabContainer: {
    marginTop: 25,
    padding: '25px 0 35px 0',
    overflow: 'hidden',
  },
  error: {
    color: 'red',
  },
  avatarPreview: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  previewText: {
    height: '100%',
    textAlign: 'center',
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: grey[700],
    display: 'inline',
  },
  avatar: {
    width: 120,
    height: 120,
    cursor: 'pointer',
    boxShadow: theme.shadows[8],
    margin: '0 auto 40px auto',
    [theme.breakpoints.up('md')]: {
      margin: '0 0 40px 8px',
    },
  },
})

export const paymentMethod = theme => ({
  noCatalogsMessage: {
    marginTop: 35,
    color: 'rgba(0,0,0,.54)',
    textAlign: 'center',
  },
  container: {
    marginTop: 50,
  },
  linkContainer: {
    textAlign: 'right', marginTop: 10,
  },
  textContainer: {
    padding: '0 10px',
  },
  avatar: {
    backgroundColor: grey[400],
  },
  mainCard: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/profile/styles.js